<template>
	<div id="delete-custom-lut-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Delete LUT</span>
		<p class="description">Are you sure you want to delete LUT: <br />"<span>{{ lutName }}</span>"?</p>
		<div class="buttons-continer">
            <v-btn @click="confirm" :disabled="processing" dark class="modal-btn --primary --delete">
                <v-progress-circular v-if="processing" color="#fff" indeterminate size="18" width="3" />
                <template v-else>Delete</template>
            </v-btn>
			<button @click="close" type="button" class="modal-btn --cancel">Cancel</button>
		</div>
	</div>
</template>

<script>
import FilenameMixin from "@/mixins/Filename";
import { mapState } from "vuex";
import { toString } from "lodash";

export default {
    mixins: [FilenameMixin],

    data() {
        return {
            processing: false
        }
    },

    computed: {
        ...mapState('UserFilesCustomLuts', ['lutToDelete']),
        lutName() {
            if (!this.lutToDelete.name) return;
            return this.stripExtension(this.lutToDelete.name)
        }
    },

    methods: {
        async confirm() {
            this.processing = true;
            const folder = this.$store.getters["UserFilesCustomLuts/folderByLutId"](this.lutToDelete.id)
            await this.$store.dispatch('UserFilesCustomLuts/delete', {
				folderId: folder.id,
				fileId: this.lutToDelete.id
			});
            await this.$store.dispatch('UserFilesCustomLuts/index');
            await customLutsStore.removeItem(toString(this.lutToDelete.id));

            lutPreviewer.removeCustomLutPreview(this.lutToDelete.id);
            lutPreviewer.render();

            if (window.lutify.getActiveBlock().folder.id == folder.id && folder.files.length - 1 == 0) {
                window.UI.hideLUTtemplates();
            }

            this.processing = false;

            this.close();
        },
        close() {
            window.UI.hideModal();
        }
    }
};
</script>

<style></style>
